import kolor from '@components/search/inputs/kolor'
import rodzajLakieru from '@components/search/inputs/rodzajLakieru'
import liczbaDrzwi from '@components/search/inputs/liczbaDrzwi'
import liczbaMiejsc from '@components/search/inputs/liczbaMiejsc'

const nadwozieOsobowy = { t: 'Nadwozie', inputs: [
    kolor,
    rodzajLakieru,
    liczbaDrzwi,
    liczbaMiejsc,
]}

export default nadwozieOsobowy